import React from 'react';
import { User, TransportMode } from '../types';
import TransportSelector from './TransportSelector';

interface Props {
  users: User[];
  onUsersChange: (users: User[]) => void;
}

const UserInputPanel: React.FC<Props> = ({ users, onUsersChange }) => {
  const updateUser = (index: number, updates: Partial<User>) => {
    const newUsers = [...users];
    newUsers[index] = { ...newUsers[index], ...updates };
    onUsersChange(newUsers);
  };

  const addUser = () => {
    const newId = `user-${users.length + 1}`;
    onUsersChange([
      ...users,
      {
        id: newId,
        name: `Persona ${users.length + 1}`,
        origin: '',
        availableModes: ['driving', 'transit'] as TransportMode[],
      },
    ]);
  };

  const removeUser = (index: number) => {
    if (users.length <= 2) return; // Minimum 2 users
    onUsersChange(users.filter((_, i) => i !== index));
  };

  return (
    <div className="user-input-panel">
      <h2>👥 Partecipanti</h2>

      {users.map((user, index) => (
        <div key={user.id} className="user-card">
          <div className="user-card-header">
            <input
              type="text"
              className="user-name-input"
              value={user.name}
              onChange={e => updateUser(index, { name: e.target.value })}
              placeholder="Nome"
            />
            {users.length > 2 && (
              <button
                type="button"
                className="btn-remove"
                onClick={() => removeUser(index)}
                aria-label={`Rimuovi ${user.name}`}
              >
                ✕
              </button>
            )}
          </div>

          <div className="form-field">
            <label className="field-label">Partenza</label>
            <input
              type="text"
              className="text-input"
              value={user.origin}
              onChange={e => updateUser(index, { origin: e.target.value })}
              placeholder="Es: Milano, Metro Bicocca"
            />
          </div>

          <TransportSelector
            selectedModes={user.availableModes}
            onChange={modes => updateUser(index, { availableModes: modes })}
          />
        </div>
      ))}

      <button type="button" className="btn-add-user" onClick={addUser}>
        + Aggiungi persona
      </button>
    </div>
  );
};

export default UserInputPanel;
